import { RevisionDatos } from '../../api/postRevisionDatos'
import * as Actions from './revisionMotoLeadAction'

export const version = 1
export const key = 'revisionMotoLead'

interface State {
  _version: number
  loading: boolean
  error: string | null
  datos: RevisionDatos | null
}

export const initialState: State = {
  _version: version,
  loading: false,
  error: null,
  datos: null,
}

export type RevisionLeadState = typeof initialState
export const revisionMotoLeadReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.REVISION_LEAD:
      return {
        ...state,
        loading: true,
      }
    case Actions.REVISION_LEAD_OK:
      return {
        ...state,
        loading: false,
        datos: action.payload,
      }
    case Actions.REVISION_LEAD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      }
    case Actions.REVISION_LEAD_RESET:
      return {
        ...state,
        loading: false,
        error: null,
        datos: null,
      }

    default:
      return state
  }
}
